import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { putAuthOTPUpdatePhone } from "../../../queries/auth";
import { FirstArgumentType } from "../../../types/ArgumentTypes";
import { coreService } from "../../../services/coreService";
import { buildNotifySubscriberContactMethodsQueryKey } from "../../notifications/hooks/useNotifySubscriberContactMethodsForLoggedInUser";

export function useAuthUpdatePhoneViaOTP({
  onSuccess = () => {},
  onError = () => {},
}: {
  onSuccess?: (data: Awaited<ReturnType<ReturnType<typeof putAuthOTPUpdatePhone>>>) => void;
  onError?: (error: unknown) => void;
} = {}) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();

  const [updatePhoneViaOTP, { isLoading: isUpdatingPhone }] = useMutation(putAuthOTPUpdatePhone(networkHeaders), {
    onSuccess: (data) => {
      queryCache.invalidateQueries("user");
      queryCache.invalidateQueries(buildNotifySubscriberContactMethodsQueryKey());
      onSuccess(data);
    },
    onError,
  });

  const updatePhone = async (body: FirstArgumentType<typeof coreService.authOtpUpdatePhoneUpdate>) => {
    return await updatePhoneViaOTP(body);
  };

  return { updatePhone, isUpdatingPhone };
}
